module.exports = __webpack_public_path__ + "img/download.e6245036.svg";